import {
  DISABLE_CONFIG_TRANSFER,
  DNS_ROUTING_POLICY_CREATE,
  DNS_ROUTING_POLICY_DISABLE,
  DNS_ROUTING_POLICY_UPDATE,
  DOMAIN_VERIFICATION,
  DOMAIN_VERIFICATION_DELETE,
  DOMAIN_VERIFY,
  DOMAINS,
  ENABLE_CONFIG_TRANSFER,
  GEO_LOCATIONS_URL,
  JPD_READINESS_URL,
  JPD_SSO_ENABLED_URL,
  LOG_SHIPPING_ENROLLMENT,
  LOG_STREAMER_DISABLE_TEMPORARY,
  LOG_STREAMER_TYPES,
  LOG_STREAMER_URL,
  PLATFORM_SSO_ACCESS,
  PLUGIN_STATUS_URL,
  SAML_ORGANIZATIONS,
  SAML_ORGANIZATION_BY_ID,
  SP_CERTIFICATE,
  SSL_DELETE,
  SSL_MANAGE,
  SSL_RENEW,
  SSL_SUBMIT,
  SSL_VALIDATE,
} from "@shared/services/tour/urls/settings-urls.ts";
import geoLocation from "@shared/services/tour/mockedApis/geoLocation.ts";
import logStreamer from "@shared/services/tour/mockedApis/logStreamer/logStreamer.ts";
import jpdReadiness from "@shared/services/tour/mockedApis/jpdReadiness.ts";
import pluginStatus from "@shared/services/tour/mockedApis/pluginStatus.ts";
import jpdSSOEnabled from "@shared/services/tour/mockedApis/jpdSSOEnabled.ts";
import { TourUrlMapping } from "@shared/types/localTypes/tour.ts";
import genericEmptyResponse from "@shared/services/tour/mockedApis/generic/genericEmptyResponse.ts";
import validateSsl from "@shared/services/tour/mockedApis/cdn/validateSsl.ts";
import createDnsRoutingPolicy from "@shared/services/tour/mockedApis/dnsRouting/createDnsRoutingPolicy.ts";
import updateDnsRoutingPolicy from "@shared/services/tour/mockedApis/dnsRouting/updateDnsRoutingPolicy.ts";
import enableConfigTransfer from "@shared/services/tour/mockedApis/generalSettings/enableConfigTransfer.ts";
import disableConfigTransfer from "@shared/services/tour/mockedApis/generalSettings/disableConfigTransfer.ts";
import logStreamerTypes from "@shared/services/tour/mockedApis/logStreamer/logStreamerTypes.ts";
import getDomains from "@shared/services/tour/mockedApis/domains/getDomains.ts";
import createDomainVerification from "@shared/services/tour/mockedApis/domains/createDomainVerification.ts";
import verifyDomain from "@shared/services/tour/mockedApis/domains/verifyDomain.ts";
import samlOrganizations from "@shared/services/tour/mockedApis/saml/samlOrganizations.ts";
import spCertificate from "@shared/services/tour/mockedApis/saml/spCertificate.ts";

export default {
  [GEO_LOCATIONS_URL]: () => geoLocation(),
  [LOG_STREAMER_URL]: (_, config) => logStreamer(config),
  [JPD_READINESS_URL]: () => jpdReadiness(),
  [PLUGIN_STATUS_URL]: () => pluginStatus(),
  [JPD_SSO_ENABLED_URL]: () => jpdSSOEnabled(),
  [LOG_STREAMER_DISABLE_TEMPORARY]: () => logStreamer(),
  [LOG_STREAMER_TYPES]: () => logStreamerTypes(),
  [LOG_SHIPPING_ENROLLMENT]: () => genericEmptyResponse(),
  [SSL_VALIDATE]: (data) => validateSsl(data),
  [SSL_SUBMIT]: () => genericEmptyResponse(),
  [SSL_RENEW]: () => genericEmptyResponse(),
  [SSL_MANAGE]: () => genericEmptyResponse(),
  [SSL_DELETE]: () => genericEmptyResponse(),
  [DNS_ROUTING_POLICY_CREATE]: (data) => createDnsRoutingPolicy(data),
  [DNS_ROUTING_POLICY_UPDATE]: (data, config) =>
    updateDnsRoutingPolicy(data, config),
  [DNS_ROUTING_POLICY_DISABLE]: () => genericEmptyResponse(),
  [ENABLE_CONFIG_TRANSFER]: () => enableConfigTransfer(),
  [DISABLE_CONFIG_TRANSFER]: () => disableConfigTransfer(),
  [PLATFORM_SSO_ACCESS]: () => genericEmptyResponse(),
  [DOMAINS]: () => getDomains(),
  [DOMAIN_VERIFICATION]: (data) => createDomainVerification(data),
  [DOMAIN_VERIFY]: (data, config) => verifyDomain(data, config),
  [DOMAIN_VERIFICATION_DELETE]: () => genericEmptyResponse(),
  [SAML_ORGANIZATIONS]: () => samlOrganizations(),
  [SAML_ORGANIZATION_BY_ID]: () => genericEmptyResponse(),
  [SP_CERTIFICATE]: () => spCertificate(),
} satisfies TourUrlMapping;
